// component.jsx — CardFloatingActionsComponent (UI flotante, sin dependencias externas)
import { useCardFloatingActions } from "./store";
import { styled } from "@mui/material/styles";
import { Box, Paper, Tooltip, Button, CircularProgress } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import SummarizeIcon from "@mui/icons-material/Summarize";

import { RejectModal } from "./RejectModal";
import { ResultModal } from "./ResultModal";

const FloatingBar = styled(Paper)(({ theme }) => ({
  position: "fixed",
  right: theme.spacing(3),
  bottom: theme.spacing(3),
  display: "flex",
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius * 2,
  zIndex: theme.zIndex.tooltip + 1,
  boxShadow: theme.shadows[4],
}));

export const CardFloatingActionsComponent = () => {
  const {
    quotation,
    // visibilidad
    showClientContinue, showAdminReject, showClientReject, showAdminGenerate, showClientAccept,
    // modales
    openReject, setOpenReject,
    openResult, setOpenResult,
    // acciones
    clientContinue, submitReject, submitResult, acceptAction,
    // loading
    continuing, rejecting, generating,
  } = useCardFloatingActions();

  if (!quotation) return null;

  const anyVisible = showClientContinue || showAdminReject || showClientReject || showAdminGenerate;
  if (!anyVisible) return null;

  return (
    <>
      <FloatingBar elevation={3}>
        {showClientContinue && (
          <Tooltip title="Continuar">
            <span>
              <Button
                variant="contained"
                startIcon={continuing ? <CircularProgress size={16} /> : <PlayArrowIcon />}
                onClick={clientContinue}
                disabled={continuing}
              >
                Continuar
              </Button>
            </span>
          </Tooltip>
        )}

        {(showAdminReject || showClientReject) && (
          <Tooltip title="Rechazar cotización">
            <span>
              <Button
                variant="outlined"
                color="error"
                startIcon={rejecting ? <CircularProgress size={16} /> : <DoNotDisturbIcon />}
                onClick={() => setOpenReject(true)}
                disabled={rejecting}
              >
                Rechazar
              </Button>
            </span>
          </Tooltip>
        )}

        {showAdminGenerate && (
          <Tooltip title="Generar resultado">
            <span>
              <Button
                variant="contained"
                color="secondary"
                startIcon={generating ? <CircularProgress size={16} /> : <SummarizeIcon />}
                onClick={() => setOpenResult(true)}
                disabled={generating}
              >
                Generar
              </Button>
            </span>
          </Tooltip>
        )}
        {showClientAccept && (
          <Tooltip title="Aceptar cotización">
            <span>
              <Button
                variant="contained"
                color="primary"
                startIcon={<SummarizeIcon />}
                onClick={()=>acceptAction()}
              >
                Aceptar
              </Button>
            </span>
          </Tooltip>
        )}
      </FloatingBar>

      {/* Modales locales (ya anexados en tu repo) */}
      <RejectModal
        open={openReject}
        onClose={() => setOpenReject(false)}
        onSubmit={submitReject}
        loading={rejecting}
      />

      <ResultModal
        open={openResult}
        onClose={() => setOpenResult(false)}
        onSubmit={submitResult}
        loading={generating}
      />
    </>
  );
};
